import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { LOGO_URL, stats, testimonials } from "../data";
import { fadeUp, stagger, viewport } from "../motion";

export const Results = () => (
  <section className="section results" id="results" data-testid="results-section">
    <div className="results-watermark"><img src={LOGO_URL} alt="" /></div>
    <motion.div className="section-head" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
      <motion.div variants={fadeUp}>
        <p className="eyebrow"><span className="eyebrow-dot" /> Resultados &amp; depoimentos</p>
        <h2>Prova,<br /><em>não promessa.</em></h2>
      </motion.div>
      <motion.p variants={fadeUp}>Quem trabalha com a Vanguard não fala de vaidade — fala de número, agenda cheia e crescimento que dá para medir.</motion.p>
    </motion.div>
    <motion.div className="stats" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
      {stats.map((stat) => (
        <motion.div className="stat" key={stat.label} variants={fadeUp} data-testid={`stat-${stat.label.split(" ")[0].toLowerCase()}`}>
          <strong>{stat.value}</strong><span>{stat.label}</span>
        </motion.div>
      ))}
    </motion.div>
    <motion.div className="quotes" initial="hidden" whileInView="show" viewport={viewport} variants={stagger}>
      {testimonials.map((item) => (
        <motion.figure className="quote" key={item.initials} variants={fadeUp} data-testid={`testimonial-${item.initials.toLowerCase()}`}>
          <Quote size={20} className="quote-icon" />
          <blockquote>{item.quote}</blockquote>
          <figcaption className="quote-foot">
            <span className="q-avatar">{item.initials}</span>
            <span className="q-meta"><span className="q-name">{item.name}</span><span className="q-role">{item.role}</span></span>
          </figcaption>
        </motion.figure>
      ))}
    </motion.div>
  </section>
);
